import { EModalType, IBankInfoModalContent, IBuilderInfoModalContent, IModalContent, TOfferType } from '../../../types';
import { BankInfoModalContent } from '../components/BankInfoModalContent';
import { BuilderInfoModalContent } from '../components/BuilderInfoModalContent';

interface IGetModalContentComponentByType {
  type: TOfferType | null;
  content: IModalContent | null;
}

const getBankModalContent = (content: IBankInfoModalContent) => {
  return <BankInfoModalContent redirectUrl={content.button.url} creditInfo={content} />;
};

const getBuilderModalContent = (content: IBuilderInfoModalContent) => {
  return <BuilderInfoModalContent creditInfo={content} />;
};

export const getModalContentComponentByType = ({ type, content }: IGetModalContentComponentByType) => {
  if (!content) {
    return null;
  }

  switch (type) {
    case EModalType.BANK:
      return getBankModalContent(content as IBankInfoModalContent);
    case EModalType.BUILDER:
      return getBuilderModalContent(content as IBuilderInfoModalContent);
    default:
      console.error('Unknown modal type: getModalContentComponentByType');

      return null;
  }
};
